/**
 * The keys of this enum have been renamed for clarity,
 * but the values are the same as the original constants in order to preserve backwards compatibility
 * with the API.
 */
export enum PortfolioViewMode {
  /**
   * This is the default, and historically speaking, the only mode for a given portfolio.
   */
  DEFAULT = 'Edit',
  /**
   * This is the mode for a given portfolio when the portfolio has a non-hierarchy grouping configuration.
   */
  VIEW = 'View',
}
